module.exports = __webpack_public_path__ + "static/media/ServicerSegments.2a3461fe.png";